module.exports = __webpack_public_path__ + "static/media/starbridge.8e00cc1d.png";